// extracted by mini-css-extract-plugin
export default {"container":"ModuleMaterials_container__uaPND","materials":"ModuleMaterials_materials__zJtV3"};